/*
 * @Author: zhaozhuo
 * @Date: 2022-02-28 17:21:20
 * @LastEditors: zhangquanming 419654548@qq.com
 * @LastEditTime: 2023-12-04 17:22:26
 * @Description: file content
 * @FilePath: \edc-mobile-web\src\router\patientRoute.js
 */
export default [
  {
    path: '/researchList',
    name: 'ResearchList',
    meta: {
      setMenuActive: 0,
      keepAlive: true,
      isFooter: true
    },
    component: (resolve) => require(['../views/research/index.vue'], resolve) // 首页
  },
  {
    path: '/patientVisitList',
    name: 'PatientVisitList',
    meta: {
      setMenuActive: 0,
      isNavBar: true,
      isFooter: true,
      istipTitle: true
    },
    component: (resolve) =>
      require(['../views/visit/patientVisitList/index.vue'], resolve) // 访视列表
  },
  {
    path: '/formList',
    name: 'FormList',
    meta: {
      setMenuActive: 0,
      isNavBar: true,
      isFooter: true,
      routerIconType: 4
    },
    component: (resolve) =>
      require(['../views/form/formList/index.vue'], resolve) // 推送表单列表
  },
  {
    path: '/patientFormDetail',
    name: 'PatientFormDetail',
    meta: {
      isNavBar: false,
      isHasComponent: true,
      routerIconType: 5
    },
    component: (resolve) =>
      require(['../views/form/formDetail/index.vue'], resolve) // 表单详情
  },
  {
    path: '/recruitForm',
    name: 'RecruitForm',
    meta: {},
    component: (resolve) =>
      require(['../views/recruit/recruitForm/index.vue'], resolve) // 患者招募信息录入
  },
  {
    path: '/customTemplatePreviewRedict',
    name: 'CustomTemplatePreviewRedict',
    meta: {},
    component: (resolve) =>
      require(['../views/form/formDetail/index.vue'], resolve) // 模板录入
  },
  {
    path: '/patientMessage',
    name: 'PatientMessage',
    meta: {
      setMenuActive: 1,
      isFooter: true
    },
    component: (resolve) => require(['../views/message/index.vue'], resolve) // 消息
  },
  {
    path: '/patientMine',
    name: 'PatientMine',
    meta: {
      setMenuActive: 2,
      isFooter: true
    },
    component: (resolve) => require(['../views/mine/index.vue'], resolve) // 我的
  }
]
